module.exports = __webpack_public_path__ + "static/f_capabilities_3_3-e745381e0b25e1dad0cd04510d6b77f4.png";